<!--
패킹 컴포넌트 > 경고
------------------------------------
-->
<template>
    <div class="alert" v-if="! confirmed">
        <i class="material-icons">{{ icon }}</i>
        {{ msg }}
        <i class="material-icons close" @click="confirmed = true">close</i>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // 머테리얼 아이콘
            icon: {
                type: String,
                default: 'notification_important',
            },

            // 상품정보
            msg: String,
        },
        data: function () {
            return {
                // (bool) 확인여부
                confirmed: false,
            };
        },
        computed: {
        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
    .alert {
        font-size: 1rem;
        color: #000;
        background-color: #fff;
        border: solid 1px #f0506e;
        padding: 6px;

        .material-icons {
            color: #f0506e;
            font-size: 1.5rem;
            vertical-align: middle;

            &.close {
                font-size: 1.25rem;
                color: #666;
                border: 1px solid #999;
                cursor: pointer;
            }
        }
    }
</style>